export default "__VITE_ASSET__s_5Ejlc4__"